<div
  class="flex flex-col md:flex-row items-center justify-between py-3 mt-3 mb-3">
  <div
    class="flex flex-col md:flex-row gap-y-5 md:gap-y-0 items-center md:justify-between w-full">
    <div class="flex gap-x-2 text-primary-700 font-medium items-center">
      <p class="text-sm shrink-0">Rows per page</p>
      <select
        [value]="rowsPerPage()"
        (change)="onRowsPerPageChange($event)"
        class="px-1 py-1 outline outline-neutral-400 border-r-8 border-transparent rounded-full focus:outline-none focus:ring-2 focus:ring-primary-700 font-medium font-primary text-primary-700">
        @for (size of rowsPerPageOptions; track size) {
          <option [value]="size">
            {{ size }}
          </option>
        }
      </select>
      <p class="text-sm shrink-0">of {{ total() }} rows</p>
    </div>
    <div>
      <nav class="isolate inline-flex space-x-2" aria-label="Pagination">
        <button
          (click)="goToPage(1)"
          [disabled]="!previous()"
          class="relative cursor-pointer inline-flex items-center rounded-full px-3 py-2 text-gray-400 ring-1 ring-inset ring-neutral-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed">
          <span class="sr-only">First</span>
          <icon name="doubleArrowLeft" [size]="13" fill="#155883" />
        </button>
        <button
          (click)="previousPage()"
          [disabled]="!previous()"
          class="relative inline-flex cursor-pointer items-center px-3 py-2 rounded-full text-gray-400 ring-1 ring-inset ring-neutral-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed">
          <span class="sr-only">Previous</span>
          <icon name="chevronLeft" [size]="10" fill="#155883" />
        </button>
        @for (page of pages(); track page) {
          @if (page !== '...') {
            <button
              (click)="goToPage(+page)"
              [ngClass]="{
                'bg-primary-700 text-white': currentPage() === page,
                'text-primary-700 ring-1 ring-inset ring-neutral-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0':
                  currentPage() !== page,
              }"
              class="relative inline-flex items-center px-[0.85rem] py-2 text-sm font-semibold rounded-full cursor-pointer">
              {{ page }}
            </button>
          } @else {
            <span
              class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 focus:outline-offset-0">
              ...
            </span>
          }
        }
        <button
          (click)="nextPage()"
          [disabled]="!next()"
          class="relative inline-flex items-center cursor-pointer px-3 py-2 rounded-full text-gray-400 ring-1 ring-inset ring-neutral-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed">
          <span class="sr-only">Next</span>
          <icon name="chevronRight" [size]="10" fill="#155883" />
        </button>
        <button
          (click)="goToPage(totalPages())"
          [disabled]="!next()"
          class="relative inline-flex items-center cursor-pointer px-3 py-2 rounded-full text-gray-400 ring-1 ring-inset ring-neutral-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed">
          <span class="sr-only">Last</span>
          <icon name="doubleArrowRight" [size]="13" fill="#155883" />
        </button>
      </nav>
    </div>
  </div>
</div>
